import React from 'react'
import './loading-indicator.css'

export default function LoadingIndicator (): React.ReactElement {
  return (
    <div className='loading-animation' />
  )
}
